import React from "react";
import { Button, Box, Typography, useMediaQuery } from "@mui/material";
import playStore from "assets/images/play_icon.svg";
import appStore from "assets/images/apple_icon.svg";
import {
  //isMobileSafari,
  //isSafari,
  isAndroid,
  isIOS,
} from "react-device-detect";

export const AppleStoreButton = (props) => {
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const appData = JSON.parse(sessionStorage.getItem("applicationData"));

  var appStoreUrl = appData?.organization?.organizationOptionJson?.branchIoLink;
  if (appStoreUrl == null) {
    appStoreUrl = appData?.app?.appStoreUrl;
  }
  console.log("appStoreUrl", appStoreUrl);

  return (
    <>
      {!isAndroid && (
        <>
          <Box
            onClick={() => {
              // if (isMobileSafari || isSafari) {
              //   var win = window.open(appStoreUrl);
              //   win.location = appStoreUrl;
              //   win.close();
              // } else {
              //   window.open(appStoreUrl, "_blank");
              // }
              window.open(appStoreUrl, "_blank");
            }}
            component="div"
          >
            <Button
              variant="contained"
              id={props.storeBtnId || "appStoreBtn"}
              sx={{
                backgroundColor: "#fff",
                width: "100%",
                paddingTop: "11px",
                paddingBottom: "11px",
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
            >
              <Box style={{ display: "flex" }}>
                <Box>
                  <img
                    src={appStore}
                    alt="play-store"
                    style={{ width: "37px", height: "44px" }}
                  />
                </Box>
                <Box style={{ paddingLeft: "12px", textAlign: "left" }}>
                  <Typography
                    variant="h5LatoBold"
                    sx={{ letterSpacing: "0.52px", textTransform: "none" }}
                  >
                    Download on the
                  </Typography>
                  <br />
                  <Typography
                    variant="h2LatoHeavy"
                    sx={{
                      color: "#083d4c",
                      fontSize: matchesMinWidth ? "18px" : "24px",
                      letterSpacing: "0.72px",
                      lineHeight: 0.9,
                      textTransform: "none",
                    }}
                  >
                    App Store
                  </Typography>
                </Box>
              </Box>
            </Button>
          </Box>
        </>
      )}
    </>
  );
};

export const PlayStoreButton = (props) => {
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const appData = JSON.parse(sessionStorage.getItem("applicationData"));
  let googlePlayStoreUrl =
    appData?.organization?.organizationOptionJson?.branchIoLink;
  if (googlePlayStoreUrl == null) {
    googlePlayStoreUrl = appData?.app?.googlePlayStoreUrl;
  }
  console.log("googlePlayStoreUrl", googlePlayStoreUrl);

  return (
    <>
      {!isIOS && (
        <>
          <Box
            onClick={() => {
              // if (isMobileSafari || isSafari) {
              //   let win = window.open(googlePlayStoreUrl);
              //   win.location = googlePlayStoreUrl;
              // } else {
              //   window.open(googlePlayStoreUrl, "_blank");
              // }
              window.open(googlePlayStoreUrl, "_blank");
            }}
            component="div"
          >
            <Button
              variant="contained"
              id={props.storeBtnId || "googleStoreBtn"}
              sx={{
                backgroundColor: "#fff",
                width: "100%",
                paddingTop: "11px",
                paddingBottom: "11px",
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "#fff",
                },
              }}
            >
              <Box style={{ display: "flex" }}>
                <Box>
                  <img
                    src={playStore}
                    alt="play-store"
                    style={{ width: "37px", height: "44px" }}
                  />
                </Box>
                <Box style={{ paddingLeft: "12px", textAlign: "left" }}>
                  <Typography
                    variant="h5LatoBold"
                    sx={{ letterSpacing: "0.52px", textTransform: "none" }}
                  >
                    Get it on
                  </Typography>
                  <br />
                  <Typography
                    variant="h2LatoHeavy"
                    sx={{
                      color: "#083d4c",
                      fontSize: matchesMinWidth ? "18px" : "24px",
                      letterSpacing: "0.72px",
                      lineHeight: 0.9,
                      textTransform: "none",
                    }}
                  >
                    Google Play
                  </Typography>
                </Box>
              </Box>
            </Button>
          </Box>
        </>
      )}
    </>
  );
};
